import React, { useState } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { userSelectedPlateform } from '../../../store/giftcardDesign/action';

// Styled component outside for better performance
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginRight: theme.spacing(4),
  '& .MuiTypography-root': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

const PlatformChooseSection = () => {
  // 1. Use local state instead of Redux
  const [sharePlatform, setSharePlatform] = useState(null);

  const dispatch = useDispatch();

  // 2. Handle changes internally and notify parent if needed
  const handleChange = (event) => {
    const value = parseInt(event.target.value, 10);
    setSharePlatform(value);
    dispatch(userSelectedPlateform(value));
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Share Via</FormLabel>
      <RadioGroup
        row
        aria-label="share-platform"
        name="share-platform"
        value={sharePlatform?.toString()}
        onChange={handleChange}
      >
        <StyledFormControlLabel
          value="0"
          control={<Radio color="primary" />}
          label={
            <>
              <WhatsAppIcon color="success" />
              WhatsApp Only
            </>
          }
        />
        <StyledFormControlLabel
          value="1"
          control={<Radio color="primary" />}
          label={
            <>
              <EmailIcon color="primary" />
              Email Only
            </>
          }
        />
        <StyledFormControlLabel
          value="2"
          control={<Radio color="primary" />}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <EmailIcon color="primary" />
              <WhatsAppIcon color="success" />
              Both
            </Box>
          }
        />
      </RadioGroup>
    </FormControl>
  );
};

export default PlatformChooseSection;